import { render, staticRenderFns } from "./DefaultNav.vue?vue&type=template&id=40fddfc4&scoped=true&"
import script from "./DefaultNav.vue?vue&type=script&lang=js&"
export * from "./DefaultNav.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNav.vue?vue&type=style&index=0&id=40fddfc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fddfc4",
  null
  
)

export default component.exports